// Module
var code = "<div class=\"ui-notification\"> <h3 ng-show=\"title\" ng-bind-html=\"title\"></h3> <div class=\"message\" ng-bind-html=\"message\"></div> <div class=\"footnote\" ng-if=\"t === 'e'\"> <small>{{ host }}</small> <small ng-if=\"context.db.name\"><br>{{ context.db.name }}</small> </div> </div> ";
// Exports
export default code;